import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class RecetaService {

  controller: string = "receta/";
  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }

  create(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'create', { element: data }, this.sesion.headers);
  }
  update(data: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'update/' + data.id, { element: data }, this.sesion.headers);
  }
  delete(id: number): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + 'delete/' + id, this.sesion.headers);
  }
  recetasDeProducto(idProducto: number): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `select/${idProducto}`, this.sesion.headers);
  }
  select(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'select', this.sesion.headers);
  }
}
